import AppVersions from './app-versions';

export default AppVersions;
